import { COLORS } from 'ui/constants/colors';

export const DEFAULT_OVERLAY_COLOR = COLORS.gray800;
